import type { Variants, Transition } from 'framer-motion';

/* ============================================================
   Shared spring preset — confident, not bouncy.
   ============================================================ */
export const spring: Transition = {
  type: 'spring',
  stiffness: 260,
  damping: 26,
  mass: 0.9,
};

export const springSoft: Transition = {
  type: 'spring',
  stiffness: 180,
  damping: 28,
  mass: 1,
};

export const springSnap: Transition = {
  type: 'spring',
  stiffness: 380,
  damping: 32,
  mass: 0.7,
};

/* ============================================================
   Common variants
   ============================================================ */
export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 12 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { ...spring, delay: 0.05 },
  },
  exit: { opacity: 0, y: -8, transition: { duration: 0.18 } },
};

export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.4, ease: [0.25, 1, 0.5, 1] } },
  exit: { opacity: 0, transition: { duration: 0.18 } },
};

export const scaleIn: Variants = {
  hidden: { opacity: 0, scale: 0.96 },
  visible: { opacity: 1, scale: 1, transition: spring },
  exit: { opacity: 0, scale: 0.98, transition: { duration: 0.18 } },
};

/* ============================================================
   Page transition — used by AnimatePresence in the router.
   Slightly slower than fadeUp so vault→detail morphs feel smooth.
   ============================================================ */
export const pageTransition: Variants = {
  hidden: { opacity: 0, y: 8, filter: 'blur(6px)' },
  visible: {
    opacity: 1,
    y: 0,
    filter: 'blur(0px)',
    transition: { duration: 0.35, ease: [0.25, 1, 0.5, 1] },
  },
  exit: {
    opacity: 0,
    y: -4,
    filter: 'blur(4px)',
    transition: { duration: 0.2, ease: [0.4, 0, 1, 1] },
  },
};

/* ============================================================
   Stagger container — for lists of children.
   ============================================================ */
export const staggerContainer: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.04,
      delayChildren: 0.08,
    },
  },
};

export const staggerItem: Variants = {
  hidden: { opacity: 0, y: 10 },
  visible: { opacity: 1, y: 0, transition: spring },
};